// extracted by mini-css-extract-plugin
export default {"modal-header":"AddDocument_modal-header__7z+Ej","modal-header-filter":"AddDocument_modal-header-filter__AdxcC","modal-title":"AddDocument_modal-title__k42sa"};